import { sharedService } from "@/modules/shared/store/services/shared-service";
import { populatePrepaymentPenaltyTypes } from "@/redux/reducers/prepaymentPenaltyValueTypes";

const getPrepaymentPenaltyTypes = sharedService.injectEndpoints({
  endpoints: builder => ({
    getPrepaymentPenaltyTypes: builder.query({
      query: () => "parameters/prepayment-penalty-types",
      transformResponse: response => response.items,
      providesTags: ["PrepaymentPenaltyTypes"],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(populatePrepaymentPenaltyTypes(data));
        } catch { /* handled by RTK Query error state */ }
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetPrepaymentPenaltyTypesQuery } = getPrepaymentPenaltyTypes;

